module.exports = __webpack_public_path__ + "static/media/IMG_0374_Reduced.074e4a14.jpg";